import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
// import HomeView from "@/views/HomeView.vue";
import { screenRoutes } from "./screenRoutes";
import { remoteControlRoutes } from "./remoteControlRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/screen/futuresKnowledge/index",
  },
  ...screenRoutes,
  ...remoteControlRoutes,
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
